import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TramiteEmvs } from './tramite-emvs';

@Injectable({
  providedIn: 'root'
})
export class ListadoTramitesEmvsService {

  private API_URL: string = environment.API_URL;
  constructor(private http: HttpClient) { }

  tramite?: TramiteEmvs;
  tramiteCustom?: any;

  getTramitesByuserId(id : number){
    return this.http.get<TramiteEmvs[]>(`${this.API_URL}/tramite_emvs/${id}`); 
  }

  getTramitesForCSV(){
    return this.http.get<Map<string, any[]>>(`${this.API_URL}/tramite_emvs/getForCSV`); 
  }

  downloadJustificanteB64(id: number): Observable<any> {

    let API_URL = `${this.API_URL}/nextcloud/downloadB64/${id}`;
    return this.http.get(API_URL);
  }

  downloadB64(id_documento){
    const url = `${this.API_URL}/nextcloud/downloadB64/` + id_documento;
    return this.http
      .get<any>(url);
  }

  updateJustificanteB64(form: object): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_emvs/updateFirma`;
    return this.http.post(API_URL,form);
  }


  

  deleteTramiteForm(tramite: TramiteEmvs) {
    
    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_emvs/deleteTramite`, {
      body:{id:tramite.id}
   });
  }
  getTramiteById(id : number){
    return this.http.get<TramiteEmvs>(`${this.API_URL}/tramite_emvs/get/${id}`); 
  }
  getTramiteCustomById(id : number){
    return this.http.get<any>(`${this.API_URL}/tramite_custom/get/${id}`); 
  }
  updateJustificanteB64Custom(form: object): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_custom/updateFirma`;
    return this.http.post(API_URL,form);
  }

  deleteTramiteCustom(tramite: TramiteEmvs) {
    
    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_custom/deleteTramite`, {
      body:{id:tramite}
   });
  }

  deleteTramiteFormCustom(tramite: TramiteEmvs) {
    
    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_custom/deleteTramite`, {
      body:{id:tramite.id}
   });
  }  
  deleteTramiteFormCustomById(tramite: String) {
    
    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_custom/deleteTramite`, {
      body:{id:tramite}
   });
  }  
  getProcedimientoCustomFormat(idprocedimiento: number, idUsuario:number): Observable<TramiteEmvs> {
    const url = `${this.API_URL}/tramite_custom/getCurrentWithFormat/${idprocedimiento}/usuario/${idUsuario}`;
    return this.http.get<TramiteEmvs>(url);
  }  
  checkDoesntExistRpsv(): Observable<Boolean> {
    const url = `${this.API_URL}/tramite_emvs/checkDoesntExistRpsv`;
    return this.http.get<Boolean>(url);
  }  
  checkDoesntExistSpv(idProcedimiento: number): Observable<any> {
    const url = `${this.API_URL}/tramite_emvs/checkDoesntExistSpv/${idProcedimiento}`;
    return this.http.get<any>(url);
  }
  checkTramitePendienteFirma(idProcedimiento: number): Observable<{ pendienteFirma: boolean }> {
    const url = `${this.API_URL}/tramite_emvs/checkTramitePendienteFirma/${idProcedimiento}`;
    return this.http.get<{ pendienteFirma: boolean }>(url);
  }
}
